import { tw } from '@ctw/shared/utils/tailwind';
import type { Coding } from 'fhir/r4';

type CodingListProps = {
  codings: Array<Coding>;
};

export function CodingList({ codings }: CodingListProps) {
  return (
    <div className={tw`flex flex-col`}>
      {codings.map((coding, idx) => (
        <div key={`${coding.system}-${coding.code}-${idx}`} className={tw`space-x-1`}>
          <span className={tw`font-semibold`}>{coding.code ?? ''}</span>
          <span>{coding.display ?? ''}</span>
        </div>
      ))}
    </div>
  );
}
